import { API } from '@Providers';

interface UpdateMedicalCostRetailCostPayload {
  _id: string;
  animal_id: string;
  type: string;
  retail_cost: number;
}

export default async function (payload: UpdateMedicalCostRetailCostPayload) {
  const endpoint = '/api/shelter/cart/update-medical-cost-retail-cost';

  return API({ endpoint, method: 'put', payload });
}
